import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Paper
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import axios from 'axios';
import IDConfirmationForm from './IDConfirmationForm';

const IDUploadForm = () => {
  const [status, setStatus] = useState('idle'); // idle | uploading | success | error
  const [message, setMessage] = useState('');
  const [imageURL, setImageURL] = useState('');
  const [extractedData, setExtractedData] = useState({});

  const handleFileChange = async (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (selected.size > 5 * 1024 * 1024) {
      setMessage('File must be less than 5 MB.');
      setStatus('error');
      return;
    }

    const objectURL = URL.createObjectURL(selected);
    setImageURL(objectURL);

    const formData = new FormData();
    formData.append('file', selected);

    setStatus('uploading');
    setMessage('');

    try {
      const res = await axios.post('/api/upload-id', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      console.log(res.data.extracted);
      setExtractedData(res.data.extracted);
      setStatus('success');
      setMessage('ID uploaded and analyzed successfully!');
    } catch (error) {
      console.error(error);
      setStatus('error');
      setMessage('Upload failed. Please try again.');
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" mb={3}>
        ID Upload & Auto-Fill
      </Typography>

      <input
        type="file"
        accept="image/*,.pdf"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        id="upload-id"
      />
      <label htmlFor="upload-id">
        <Button variant="contained" component="span" startIcon={<UploadFileIcon />}>
          Upload ID Image
        </Button>
      </label>

      {status === 'uploading' && <CircularProgress sx={{ mt: 2 }} />}
      {status === 'success' && <Alert sx={{ mt: 2 }} severity="success">{message}</Alert>}
      {status === 'error' && <Alert sx={{ mt: 2 }} severity="error">{message}</Alert>}

      {imageURL && (
        <Grid container spacing={2} sx={{ mt: 4 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="subtitle1" gutterBottom>
                ID Preview
              </Typography>
              <Box
                component="img"
                src={imageURL}
                alt="ID preview"
                sx={{ width: '100%', maxHeight: 400, objectFit: 'contain' }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <IDConfirmationForm extractedData={extractedData} />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default IDUploadForm;
